import { EnumEstadoCliente } from '../../api'
import { ChildSettlementGroupModel } from '../../api/Argentia/endpoints/settlementGroups/model/settlementGroups'
import { EnumTypeSettlementGroup } from '../../api/Argentia/enums/typeSettlementGroup'

export enum TabsSettlementGroup {
  groupFlexibilities = 0,
  AggregateAndSummaryInvoice = 1,
  virtualBattery = 2,
  BusinessGroup = 3
}

export type RulebookSettlementGroupAggregatedAddValidations =
  (typeof RulebookSettlementGroupAggregatedAddValidations)[keyof typeof RulebookSettlementGroupAggregatedAddValidations]

export namespace RulebookSettlementGroupAggregatedAddValidations {
  export const IBAN = 'iban'
}

export interface SettlementGroupAggregatedAddFormValidations {
  all: boolean
  iban: boolean
  postalCode: boolean
  subject: boolean
}
export interface SettlementGroupAggregatedEditFormValidations {
  all: boolean
  iban: boolean
  postalCode: boolean
}

export enum SettlementGroupAggregatedEditFormDataSections {
  header = 1,
  payment,
  billingAddress
}
export interface SettlementGroupAggregatedEditFormIsDirty {
  all: boolean
  header: boolean
  payment: boolean
  billingAddress: boolean
}
export namespace RulebookSettlementGroupAggregatedEditValidations {
  export const IBAN = 'iban'
  export const POSTAL_CODE = 'postalCode'
}

export type RulebookSettlementGroupAggregatedEditValidations =
  (typeof RulebookSettlementGroupAggregatedEditValidations)[keyof typeof RulebookSettlementGroupAggregatedEditValidations]

export enum EnumSettlementGroupMoveTo {
  ORDER_UP = 'UP',
  ORDER_DOWN = 'DOWN'
}

export type SetllementGroupContractRow = {
  id: number
  contractId: number
  contractCode: string
  description: string | undefined
  contractStartDate: Date
  contractEndDate: Date
  status?: EnumEstadoCliente
  vinculationStartDate: Date
  vinculationEndDate: Date | null
  percentage: number | null
  order?: number
  isNotFirstOne: boolean
  isNotLastOne: boolean
}

export type SetllementGroupSubjectRow = {
  id: number
  contractId: number
  contractCode: string
  description: string | undefined
  contractStartDate: Date
  contractEndDate: Date
  status?: EnumEstadoCliente
}

export interface SettlementGroupVirtualEditFormDataType {
  id: number
  code: string
  description: string
}

export type ChildSettlementGroupTableData = ChildSettlementGroupModel & {
  childGroupCode?: string
  childGroupDescription?: string
  childType?: EnumTypeSettlementGroup
}

export type FormAddChildSettlementGroup = {
  childSettlementGroupId?: number
  vinculationStartDate: Date | undefined
  vinculationEndDate?: Date
}
